//* External
import { toast } from 'react-toastify';

//* App Custom
import { APIS } from '@constantsApp/index';
import { tnl } from '@i18nApp/i18n';
import { doingRequest, requestFinalized, store } from '@reduxApp/index';
import { sendRequest } from '@utilsApp/index';

export const createPeopleEmail = ({ data }) => {
  sendRequest({
    url: APIS.PEOPLE.EMAIL,
    method: 'post',
    data,
    thenFunction: (res) => {
      if (res.status === 201) {
        toast.success(tnl('toasts.email_create'));
      }
    }
  });
};

export const updatePeopleEmail = ({ data }) => {
  store.dispatch(doingRequest());
  sendRequest({
    url: `${APIS.PEOPLE.EMAIL}${data.pk}/`,
    method: 'patch',
    data,
    thenFunction: (res) => {
      if (res.status === 200) {
        store.dispatch(requestFinalized());
        toast.success(tnl('toasts.email_updated'));
      }
    }
  });
};

export const createPeoplePhone = ({ data }) => {
  sendRequest({
    url: APIS.PEOPLE.PHONE,
    method: 'post',
    data,
    thenFunction: (res) => {
      if (res.status === 201) {
        toast.success(tnl('toasts.phone_create'));
      }
    }
  });
};

export const updatePeoplePhone = ({ data }) => {
  store.dispatch(doingRequest());
  sendRequest({
    url: `${APIS.PEOPLE.PHONE}${data.pk}/`,
    method: 'patch',
    data,
    thenFunction: (res) => {
      if (res.status === 200) {
        store.dispatch(requestFinalized());
        toast.success(tnl('toasts.phone_updated'));
      }
    }
  });
};

export const deletePeoplePhone = ({ data, onSuccess = () => {} }) => {
  store.dispatch(doingRequest());
  sendRequest({
    url: `${APIS.PEOPLE.PHONE}${data.pk}/`,
    method: 'delete',
    thenFunction: (res) => {
      if (res.status === 204) {
        toast.info(tnl('toasts.phone_delete'));
        store.dispatch(requestFinalized());
        onSuccess();
      }
    }
  });
};
